import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const buyers = [{
  name: 'María L.',
  city: 'Buenos Aires'
}, {
  name: 'Juan P.',
  city: 'Córdoba'
}, {
  name: 'Sofía R.',
  city: 'Rosario'
}, {
  name: 'Carlos M.',
  city: 'Mendoza'
}, {
  name: 'Ana G.',
  city: 'CABA'
}, {
  name: 'Pedro S.',
  city: 'La Plata'
}, {
  name: 'Laura T.',
  city: 'Tucumán'
}, {
  name: 'Diego F.',
  city: 'Mar del Plata'
}, {
  name: 'Valentina K.',
  city: 'Salta'
}, {
  name: 'Nicolás B.',
  city: 'Santa Fe'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 15) + 1;
}
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    const showFirst = setTimeout(() => {
      setVisible(true);
    }, 5000);
    return () => clearTimeout(showFirst);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
      const nextTimer = setTimeout(() => {
        setCurrent(prev => (prev + 1) % buyers.length);
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, 8000 + Math.random() * 7000);
      return () => clearTimeout(nextTimer);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [visible, current]);
  const buyer = buyers[current];
  return <AnimatePresence data-id="element-115">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 80,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 80
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-orange/20 p-4 flex items-center gap-3 max-w-xs" data-id="element-116">
          <div className="bg-orange/10 p-2 rounded-full shrink-0" data-id="element-117">
            <ShoppingBag size={20} className="text-orange" data-id="element-118" />
          </div>
          <div data-id="element-119">
            <p className="text-sm font-bold text-navy" data-id="element-120">
              {buyer.name}{' '}
              <span className="font-normal text-gray-500" data-id="element-121">de {buyer.city}</span>
            </p>
            <p className="text-xs text-gray-400" data-id="element-122">
              Compró el Kit hace {minutes} min
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}